import { ConfigDiscount } from "../modules/discuontConfig";

export const DiscountPage = () => {
  return <ConfigDiscount />;
};
